module.exports = __webpack_public_path__ + "img/5a7d0b8613cdf.6da516d5.jpg";